import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenCheckmarkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 12,
		fill: "#0B9952"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.5 12L10.5 15L16.5 9",
		stroke: "white",
		strokeWidth: 2
	})]
});
export default SvgGreenCheckmarkIcon;
